import React from 'react'
import styled from 'styled-components'

const bgMap = {
  primary: 'careers_midblue',
  secondary: 'careers_orange',
  white: 'white'
}

const colorMap = {
  primary: 'white',
  secondary: 'white',
  white: 'careers_blue'
}

const ButtonContainer = styled.a`
  border-radius: 8px;
  background-color: ${(props) => props.theme.colors[bgMap[props.variant]]};
  color: ${(props) => props.theme.colors[colorMap[props.variant]]};
  padding: 10px 20px;
  // font-size: 20px;
  font-weight: bold;
  line-height: 1;
  text-decoration: none;
  display: inline-block;
  text-align: center;
  min-width: 250px;
  margin-top: 20px;

  @media (min-width: 960px) {
    min-width: 250px;
    padding: 14px 20px;
    border-radius: 12px;
  }

  @media (max-width: 959px) {
    margin: 0 auto;
  }

  &:hover,
  &:focus {
    color: ${(props) => props.theme.colors[colorMap[props.variant]]} !important;
    text-decoration: underline !important;
  }
`

const Button = ({ href, variant, children }) => {
  return (
    <ButtonContainer variant={variant} href={href}>
      {children}
    </ButtonContainer>
  )
}

export default Button
